import { makeVar } from '@apollo/client';
export const sidebarComponentId = makeVar(null);
export const sidebarModelSpecificationId = makeVar(null);
export const isUserLoggedIn = makeVar(false);
export const organizationProductsFilters = makeVar({
    name: '',
    category: '',
    categoryId: [],
    supplier: '',
    supplierId: [],
    status: '',
    statusId: '',
});
export const sharedProductsFilters = makeVar({
    name: '',
    category: '',
    categoryId: [],
    supplier: '',
    supplierId: [],
});
export const assigningSharedProductsFilters = makeVar({
    name: '',
    supplier: '',
    supplierId: [],
});
export const assigningMyProductsFilters = makeVar({
    name: '',
    supplier: '',
    supplierId: [],
});
export const organizationSuppliersFilters = makeVar({
    name: '',
    status: '',
    statusId: '',
});
export const organizationOrderOperatorsFilters = makeVar({
    name: '',
});
